import React from 'react';
import Barcode from 'react-barcode';
import '../print.css';
import bispharmaLogo from 'statics/media/logo-bisnago-peb.png';

function TagBisnagoSimple({ tagData }) {


  return (
    <div id='tag-bisnago-simple-container'>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img style={{ width: '70px', height: '20px', marginLeft: '1px' }} src={bispharmaLogo} alt='Bisnago' />
        <span style={{ fontSize: '10px' }}>{tagData?.line} N° {tagData?.number}</span>

      </div>


      <div>
        <Barcode
          value={tagData?.barcode}
          width={1.4}
          height={25}
          margin={3}
          displayValue={false}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <span style={{ fontSize: '10px' }}>{tagData.date}</span>
        <span style={{ fontSize: '10px' }}>{tagData?.hour}</span>

      </div>

    </div>
  );
}

export default TagBisnagoSimple;